import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Subtitle,
    Title,
    IntroButton,
    ButtonContainer,
    DescriptionTitle,
    DescriptionItemsContainer,
    SliderContainer,
} from './styled';
import { DescriptionCard, PageSection } from 'components';
import { DESCRIPTION_CARDS } from 'consts';
import { CardConfig } from 'components/description-card/DescriptionCard';
import {
    TitleSlider,
    Counter,
    SliderArrow,
} from 'containers/pages/for-governments/components/intro/styled';
import { Icon } from 'kl-b2c-ui-kit';
import { DotsContainer, DotsList } from '../reviews/styled';
import Slider, { Settings } from 'react-slick';
import { SliderStyler } from '../courses/styled';

const sectionConfig = {
    CWrap: {
        css: {},
    },
    ContentArea: {
        css: {
            paddingTop: 100,
            paddingBottom: 90,
            display: 'block',
            zIndex: 5,

            '@media(max-width: 1279px)': {
                paddingBottom: 20,
            },
        },
    },
};

export const Intro = () => {
    const { t } = useTranslation('pages/for-businesses');
    const [currentTitle, setCurrentTitle] = useState<number>(0);

    const CAROUSEL_SETTINGS: Settings = {
        slidesToScroll: 2,
        infinite: false,
        slidesToShow: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        appendDots: (dots) => (
            <DotsContainer>
                <DotsList> {dots} </DotsList>
            </DotsContainer>
        ),
    };

    return (
        <PageSection config={sectionConfig}>
            <Title>{t(`title-${currentTitle}`)}</Title>
            <Subtitle>{t('subtitle')}</Subtitle>

            <ButtonContainer>
                <IntroButton
                    size={'large'}
                    onClick={() =>
                        (window.location.href = 'mailto:Academy@kaspersky.com')
                    }>
                    {t('intro-button')}
                </IntroButton>
                <TitleSlider>
                    <SliderArrow
                        onClick={() => {
                            if (currentTitle !== 0) {
                                setCurrentTitle((prev) => prev - 1);
                            }
                        }}>
                        <Icon
                            name={'ArrowLeftThin'}
                            color={'white'}
                            size={24}
                        />
                    </SliderArrow>
                    <Counter>
                        {currentTitle + 1} <span>/ 6</span>
                    </Counter>
                    <SliderArrow
                        onClick={() => {
                            if (currentTitle < 6 - 1) {
                                setCurrentTitle((prev) => prev + 1);
                            }
                        }}>
                        <Icon
                            name={'ArrowRightThin'}
                            color={'white'}
                            size={24}
                        />
                    </SliderArrow>
                </TitleSlider>
            </ButtonContainer>

            <DescriptionTitle>{t('intro-description-title')}</DescriptionTitle>
            <DescriptionItemsContainer>
                {DESCRIPTION_CARDS.map((item: CardConfig) => (
                    <DescriptionCard
                        key={item.title}
                        type={'primary'}
                        config={{ ...item, title: t(item.title) }}
                    />
                ))}
            </DescriptionItemsContainer>
            <SliderContainer>
                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS}>
                        {DESCRIPTION_CARDS.map((item: CardConfig) => (
                            <DescriptionCard
                                key={item.title}
                                type={'primary'}
                                config={{ ...item, title: t(item.title) }}
                            />
                        ))}
                    </Slider>
                </SliderStyler>
            </SliderContainer>
        </PageSection>
    );
};
